import { addDays } from 'helper/timeLabels';

// The times « Programmer l'envoi » offers, as Gmail does: tomorrow morning,
// tomorrow afternoon and next Monday morning.
const MORNING = 8;
const AFTERNOON = 13;

const at = (day, hour) => {
  const date = new Date(day);
  date.setHours(hour, 0, 0, 0);
  return date;
};

/**
 * The quick times to program an e-mail from `now`: [{ id, at }]. Monday
 * morning is left out when it is tomorrow morning already.
 */
export const scheduleSlots = (now) => {
  const tomorrow = addDays(now, 1);
  const monday = addDays(now, ((8 - now.getDay()) % 7) || 7);
  return [
    { id: 'tomorrowMorning', at: at(tomorrow, MORNING) },
    { id: 'tomorrowAfternoon', at: at(tomorrow, AFTERNOON) },
    monday.getDate() !== tomorrow.getDate() && { id: 'mondayMorning', at: at(monday, MORNING) },
  ].filter(Boolean);
};

// The default of « Choisir une date et une heure »: tomorrow at 8:00.
export const defaultCustomSlot = (now) => at(addDays(now, 1), MORNING);

export const isMail = (value) => /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/.test(value.trim());
